class CollectionBannersTest {
  constructor() {
    this.testVars = ['collectionBanner1Test', 'collectionBanner2Test'];
    this.applyState = this.applyState.bind(this);
    this.handleSectionLoad = this.handleSectionLoad.bind(this);
    this.handleResize = this.debounce(this.applyState, 150);

    this.init();
  }

  init() {
    this.testVars.forEach((testVarName) => this.watchWindowVariable(testVarName));
    this.applyState();

    window.callbacks_pagination_after_change =
      window.callbacks_pagination_after_change || [];
    window.callbacks_pagination_after_change.push(this.applyState);

    window.callbacks_filters_after_render_products =
      window.callbacks_filters_after_render_products || [];
    window.callbacks_filters_after_render_products.push(this.applyState);

    window.addEventListener('resize', this.handleResize);
    document.addEventListener('shopify:section:load', this.handleSectionLoad);
  }

  handleSectionLoad(event) {
    this.applyState();
  }

  isActive(value) {
    return value === true || value === 'true';
  }

  applyState() {
    document
      .querySelectorAll('[data-section-type="collection-template"]')
      .forEach((section) => {
        this.testVars.forEach((testVarName, index) => {
          const bannerIndex = index + 1;

          if (
            this.isActive(window[testVarName]) ||
            this.isForced(section, bannerIndex)
          ) {
            this.showBanner(section, bannerIndex);
          } else {
            this.removeBanner(section, bannerIndex);
          }
        });
      });
  }

  isForced(section, bannerIndex) {
    const template = section.querySelector(
      `[data-collection-banner-template="${bannerIndex}"]`
    );
    const bannerElement = template?.content?.firstElementChild;

    return bannerElement?.dataset?.collectionBannerForce === 'true';
  }

  showBanner(section, bannerIndex) {
    const list = section.querySelector('[data-collection-products-list]');
    const template = section.querySelector(
      `[data-collection-banner-template="${bannerIndex}"]`
    );

    if (!list || !template) {
      return;
    }

    this.removeBanner(section, bannerIndex);

    const bannerElement = template.content.firstElementChild;

    if (!bannerElement) {
      return;
    }

    const banner = bannerElement.cloneNode(true);
    banner.removeAttribute('data-collection-banner-hidden');

    if (bannerIndex === 1) {
      list.prepend(banner);
      requestAnimationFrame(() => this.alignBannerToFirstProductRow(banner, list));
      this.initializeCountdowns(banner);
      return;
    }

    const productItems = [
      ...list.querySelectorAll('[data-collection-product-item]'),
    ];
    const targetProduct = this.getLastProductInFirstRow(productItems);

    if (targetProduct) {
      targetProduct.insertAdjacentElement('afterend', banner);
    } else {
      list.appendChild(banner);
    }
  }

  alignBannerToFirstProductRow(banner, list) {
    if (!banner.isConnected) {
      return;
    }

    const productItems = [
      ...list.querySelectorAll('[data-collection-product-item]'),
    ];

    if (!productItems.length) {
      return;
    }

    const firstRowTop = productItems[0].offsetTop;
    const firstRowItems = productItems.filter(
      (item) => item.offsetTop === firstRowTop
    );
    const firstItem = firstRowItems[0];
    const lastItem = firstRowItems[firstRowItems.length - 1];
    const left = firstItem.offsetLeft;
    const width = lastItem.offsetLeft + lastItem.offsetWidth - left;

    banner.style.flexBasis = `${width}px`;
    banner.style.marginLeft = `${left}px`;
    banner.style.marginRight = '0';
    banner.style.width = `${width}px`;
  }

  async initializeCountdowns(banner) {
    if (banner.querySelector('[data-countdown]:not([data-countdown-mode="interval"])')) {
      const { default: CountdownTimer } = await import('./CountdownTimer');
      new CountdownTimer(banner);
    }

    if (banner.querySelector('[data-countdown][data-countdown-mode="interval"]')) {
      const { default: CountdownTimeInterval } = await import(
        './CountdownTimeInterval'
      );
      new CountdownTimeInterval(banner);
    }
  }

  removeBanner(section, bannerIndex) {
    section
      .querySelectorAll(`[data-collection-banner="${bannerIndex}"]`)
      .forEach((banner) => banner.remove());
  }

  getLastProductInFirstRow(productItems) {
    if (!productItems.length) {
      return null;
    }

    const firstRowTop = productItems[0].offsetTop;
    return (
      productItems
        .filter((item) => item.offsetTop === firstRowTop)
        .pop() || productItems[0]
    );
  }

  watchWindowVariable(testVarName) {
    const descriptor = Object.getOwnPropertyDescriptor(window, testVarName);

    if (descriptor && !descriptor.configurable) {
      return;
    }

    let currentValue = window[testVarName];
    const enumerable = descriptor?.enumerable ?? true;
    const originalGetter = descriptor?.get;
    const originalSetter = descriptor?.set;

    Object.defineProperty(window, testVarName, {
      configurable: true,
      enumerable,
      get() {
        return originalGetter ? originalGetter.call(window) : currentValue;
      },
      set: (value) => {
        if (originalSetter) {
          originalSetter.call(window, value);
        } else {
          currentValue = value;
        }

        this.applyState();
      },
    });
  }

  debounce(callback, delay) {
    let timeoutId;

    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => callback(...args), delay);
    };
  }
}

export default CollectionBannersTest;
